<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3e96yb/tc-custom/9783956769139_IMGJPG_FrontCover_0.jpg" alt="This image is the cover for the book Agamemnon, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Agamemnon, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Aischylos (* 525 v. Chr. in Eleusis, Attika; † 456 v. Chr. in Gela, Sizilien) ist vor Sophokles und Euripides der älteste der drei großen Dichter der griechischen Tragödie. Von seinen sieben erhaltenen Stücken werden vor allem die Perser und die Orestie weltweit gespielt. Als Soldat nahm er 490 v. Chr. für Athen an der Schlacht bei Marathon gegen die Perser teil, in der sein Bruder Kynaigeiros getötet wurde. Nach der Zerstörung Athens im Jahre 480 v. Chr. war er auf einem der griechischen Kriegsschiffe an der Seeschlacht von Salamis beteiligt. Er unternahm mehrere Reisen nach Sizilien, so auch 475 v. Chr. auf Einladung des dortigen Tyrannen Hieron I. von Syrakus, und traf dort auf die Lyriker Simonides, Pindar und Bakchylides. Für Hieron verfasste er das Festspiel Die Ätnäerinnen. Im Jahr 472 v. Chr. gewann er den Siegespreis mit der Uraufführung des Dramas Die Perser, bei dem es sich um eine dramatisierte Fassung seiner Kriegserfahrungen handelt. Im Wettstreit mit Sophokles unterlag er im Jahre 468 v. Chr., doch konnte er bei den Dionysien insgesamt 13 Siege erringen. Von seiner letzten Sizilienreise kehrte er nicht mehr zurück. Er starb 456 v. Chr. in Gela, wo er auch begraben wurde. Der Legende nach hatte er sich dort auf die Felder zurückgezogen, weil ihm ein Orakel geweissagt hätte, dass er beim Einsturz eines Hauses sterben sollte. Da flog ein Adler mit einer Schildkröte im Schnabel vorbei, die er auf einem Felsen zerschellen lassen wollte, um an ihr Inneres zu gelangen. Der Vogel verwechselte Aischylos' Glatze von oben mit einem Stein, ließ los, und die Beute erschlug den Dichter. (Auszug aus Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aischylos
      </h2>
      
      <p class="authorDescription body article">Aischylos, * 525 v. Chr. in Eleusis, Attika; † 456 v. Chr. in Gela, Sizilien) ist vor Sophokles und Euripides der älteste der drei großen Dichter der griechischen Tragödie. Von seinen sieben erhaltenen Stücken werden vor allem die Perser und die Orestie weltweit gespielt. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b6c4b7d